import { PARTNER } from "@src/partner"
import { callApi } from "../callApi"

export const getPartnerUuid = async (partnerUuid: string) => {
  return callApi<null, PARTNER>({ method: "GET", path: `/partner/${partnerUuid}` })
}
